module.exports = __webpack_public_path__ + "img/avatar.f18250a8.png";